import { IProfile } from '../models/profile';
import { IResult } from '../models/result-models';
import { apiGet, apiPut, apiPost } from './api-utils';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/profile';

export const getProfile = async (): Promise<IResult<IProfile>> => {
    const result = await apiGet<IProfile>(baseUrl);
    return result;
};

export const saveProfile = async (
    profile: IProfile
): Promise<IResult<IProfile>> => {
    const result = await apiPut<IProfile, IProfile>(baseUrl, profile);
    return result;
};

export const optInOutRequest = async (
    email: string,
    phoneNumber: string,
    optInValue: boolean
): Promise<IResult<void>> => {
    return await apiPost(baseUrl + `/opt-in`, {
        optInValue,
        phoneNumber,
        email,
    });
};

export const savePatientConsent = async (): Promise<void> => {
    await apiPut(baseUrl + '/patient-consent', true);
};
